export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";